import Vue from 'vue';
import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';

const state = {
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  isMetaFetching: false,
};

export const getters = {
  getStats: $state => $state,
};

export const actions = {
  async get({ commit, state }, params) {
    if (state.isMetaFetching) {
      console.log('Meta API call skipped: already in progress');
      return;
    }

    commit(types.SET_META_FETCH_STATUS, true);
    console.log('Fetching meta data...');
    try {
      const response = await ConversationApi.meta(params);
      const {
        data: { meta },
      } = response;
      commit(types.SET_CONV_TAB_META, meta);
    } catch (error) {
      console.error('Error fetching meta data:', error);
    } finally {
      setTimeout(() => {
        commit(types.SET_META_FETCH_STATUS, false);
        console.log('Meta fetch status reset');
      }, 1000);
    }
  },
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META](
    $state,
    {
      mine_count: mineCount,
      unassigned_count: unAssignedCount,
      all_count: allCount,
    } = {}
  ) {
    Vue.set($state, 'mineCount', mineCount);
    Vue.set($state, 'allCount', allCount);
    Vue.set($state, 'unAssignedCount', unAssignedCount);
  },
  [types.SET_META_FETCH_STATUS]($state, status) {
    Vue.set($state, 'isMetaFetching', status);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
